<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="mt-3 flex flex-row gap-2">
    <uni-field label="Manufacturer Name">
      <input [ngModel]="mfg.name" pInputText disabled="true" />
    </uni-field>
    <uni-field label="Purchase Order ID">
      <input [ngModel]="poHeader.id" pInputText disabled="true" />
    </uni-field>
    <uni-field label="Status">
      <input [ngModel]="poHeader.poStatus?.name" pInputText disabled="true" />
    </uni-field>
  </div>

  <div class="mt-3 flex flex-row gap-2">
    <uni-field label="Warehouse Contact">
      <input [ngModel]="mfg.whContact" pInputText disabled="true" />
    </uni-field>
    <uni-field label="Purchase Order Email" hint="Separate multiple addresses with semicolons">
      <input [(ngModel)]="emailAddress" name="emailAddress" pInputText />
    </uni-field>
  </div>

  <div *ngIf="isPrinting">If the P/O is <b>successfully printed</b>, it can be moved to <b>Open/Incomplete</b> status.</div>
  <div *ngIf="isOpenIncomplete">This P/O is in Open/Incomplete status.</div>
</ng-template>

<ng-template #footerTemplate>
  <div *ngIf="!isPrinting">
    <div class="flex flex-row gap-2">
      <button id="poPreviewButton" *ngIf="canPreview" [disabled]="isBusy()" (click)="showPreview()" pButton type="button" class="p-button-raised">Preview</button>
      <button id="poEmailButton" [disabled]="!canSendEmail() || isBusy()" (click)="sendEmail()" pButton type="button" class="p-button-raised">
        <i *ngIf="isBusy()" class="pi pi-spinner pi-spin mr-2"></i>
        Email
      </button>
      <button id="poPrintButton" [disabled]="isBusy()" (click)="printDocument()" pButton type="button" class="p-button-raised">Print</button>
      <button id="poCloseButton" [disabled]="isBusy()" (click)="close()" pButton type="button" class="p-button-raised">Close</button>
    </div>
  </div>
  <div *ngIf="isPrinting">
    <div class="flex flex-row gap-2">
      <button id="poSetStatusButton" (click)="setStatusOpen()" pButton type="button" class="p-button-raised">
        Set to Open/Incomplete Status
      </button>
      <button id="poCancelButton" (click)="isPrinting = false" pButton type="button" class="p-button-raised">Cancel</button>
    </div>
  </div>
</ng-template>
